import { useEffect, useRef } from 'react'

const useInterval = (callback: () => void, delay: number, stop: boolean): void => {
  const savedCallback = useRef(null)

  useEffect(() => {
    savedCallback.current = callback
  })

  useEffect(() => {
    function tick() {
      savedCallback.current()
    }
    const id = setInterval(tick, delay)
    if (stop) clearInterval(id)
    return () => clearInterval(id)
  }, [stop])
}

export default useInterval
